import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import Button from "../components/Button";
import StatusBanner from "../components/StatusBanner";
import Footer from "components/Footer/Footer";
import { isSupabaseConfigured, supabase } from "../lib/supabase";

export default function Login({ error: propError }) {
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const errorMsg = propError || location.state?.error;

  async function handleGoogleLogin() {
    setIsLoading(true);

    await supabase.auth.signInWithOAuth({
      provider: "google",
      options: {
        redirectTo: `${window.location.origin}/mentorship`,
        queryParams: {
          prompt: "select_account",
        },
      },
    });
  }

  return (
    <div className="mentorship-page">
      <div className="mentorship-login-section">
        <div className="mentorship-login-grid">
          {/* Left info section */}
          <div>
            <p className="mentorship-eyebrow">
              Student Welfare Group, IIT Kharagpur
            </p>
            <h1 className="mentorship-login-heading">
              Mentorship Dashboard
            </h1>
          </div>

          {/* Right login card */}
          <div className="mentorship-login-card">
            <h2 style={{ fontSize: "20px", fontWeight: 700, color: "#00293A" }}>
              Sign in
            </h2>
            <p
              style={{
                marginTop: "8px",
                fontSize: "14px",
                lineHeight: "1.6",
                color: "#475569",
              }}
            >
              Sign in using your Google account to access the mentorship
              dashboard.
            </p>

            {!isSupabaseConfigured ? (
              <div style={{ marginTop: "20px" }}>
                <StatusBanner tone="amber">
                  Supabase is not configured yet. Create a <strong>.env</strong>{" "}
                  file from <strong>.env.example</strong>, then set{" "}
                  <strong>REACT_APP_SUPABASE_URL</strong> and{" "}
                  <strong>REACT_APP_SUPABASE_ANON_KEY</strong>.
                </StatusBanner>
              </div>
            ) : null}

            {errorMsg ? (
              <div style={{ marginTop: "20px" }}>
                <StatusBanner tone="red">{errorMsg}</StatusBanner>
              </div>
            ) : null}

            <div style={{ marginTop: "24px" }}>
              <Button
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                }}
                disabled={!isSupabaseConfigured}
                isLoading={isLoading}
                onClick={handleGoogleLogin}
                type="button"
                variant="secondary"
              >
                <svg
                  style={{ width: "20px", height: "20px" }}
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                    fill="#4285F4"
                  />
                  <path
                    d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                    fill="#34A853"
                  />
                  <path
                    d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
                    fill="#FBBC05"
                  />
                  <path
                    d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                    fill="#EA4335"
                  />
                </svg>
                Sign in with Google
              </Button>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
